/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Export_All_NotesInputs */

const en_read_along_export_all_notes = /** @type {(inputs: Read_Along_Export_All_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export All Notes`)
};

const es_read_along_export_all_notes = /** @type {(inputs: Read_Along_Export_All_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar todas las notas`)
};

/**
* | output |
* | --- |
* | "Export All Notes" |
*
* @param {Read_Along_Export_All_NotesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_export_all_notes = /** @type {((inputs?: Read_Along_Export_All_NotesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Export_All_NotesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_export_all_notes(inputs)
	return en_read_along_export_all_notes(inputs)
});